export const NATIONALITIES = [
  "Jamaican", "American", "Canadian", "British", "Trinidadian", "Bahamian", "Barbadian",
  "Guyanese", "Haitian", "Cuban", "Dominican", "Grenadian", "St. Lucian", "Vincentian",
  "Antiguan", "Kittitian", "Belizean", "Panamanian", "Costa Rican", "Mexican", "Brazilian",
  "Colombian", "Venezuelan", "Argentine", "Chilean", "Peruvian", "Spanish", "French",
  "German", "Italian", "Dutch", "Belgian", "Portuguese", "Swiss", "Irish", "Scottish",
  "Swedish", "Norwegian", "Danish", "Polish", "Russian", "Ukrainian", "Greek", "Turkish",
  "Israeli", "Egyptian", "Nigerian", "Ghanaian", "Kenyan", "South African", "Ethiopian",
  "Moroccan", "Indian", "Pakistani", "Bangladeshi", "Chinese", "Japanese", "Korean",
  "Filipino", "Vietnamese", "Thai", "Indonesian", "Malaysian", "Singaporean", "Australian",
  "New Zealander", "Emirati", "Saudi", "Lebanese", "Jordanian", "Other",
];

export const COUNTRIES = [
  "Jamaica", "United States", "Canada", "United Kingdom", "Trinidad & Tobago", "Bahamas",
  "Barbados", "Guyana", "Haiti", "Cuba", "Dominican Republic", "Grenada", "Saint Lucia",
  "Cayman Islands", "Antigua & Barbuda", "Belize", "Panama", "Costa Rica", "Mexico",
  "Brazil", "Colombia", "Venezuela", "Argentina", "Chile", "Peru", "Spain", "France",
  "Germany", "Italy", "Netherlands", "Belgium", "Portugal", "Switzerland", "Ireland",
  "Sweden", "Norway", "Denmark", "Poland", "Russia", "Greece", "Turkey", "Israel",
  "United Arab Emirates", "Saudi Arabia", "Egypt", "Nigeria", "Ghana", "Kenya",
  "South Africa", "Morocco", "India", "Pakistan", "China", "Japan", "South Korea",
  "Philippines", "Vietnam", "Thailand", "Indonesia", "Malaysia", "Singapore",
  "Australia", "New Zealand", "Other",
];
